export type PartnerBranding = {
  menu: {
    expanded: string;
    collapsed: string;
  };
  /** Favicon da aba do navegador (PNG recomendado, ex. 32×32 ou 64×64). */
  favicon: string;
  /** Ícone ao adicionar à tela inicial (iOS/Android). Opcional — usa favicon se omitido. */
  appleTouchIcon?: string;
};

/**
 * Branding por parceiro (arquivos em /public/partners/).
 * Ative com REACT_APP_PARTNER_NAME=abo (ou outro slug listado aqui).
 */
const PARTNER_BRANDING: Record<string, PartnerBranding> = {
  abo: {
    menu: {
      expanded: '/partners/abo.png',
      collapsed: '/partners/abo.png',
    },
    favicon: '/partners/abo-favicon.png',
    appleTouchIcon: '/partners/abo-favicon.png',
  },
};

export function getPartnerName(): string | null {
  const raw = (process.env.REACT_APP_PARTNER_NAME || '').trim().toLowerCase();
  return raw || null;
}

export function getPartnerBranding(): PartnerBranding | null {
  const partner = getPartnerName();
  if (!partner) return null;

  const branding = PARTNER_BRANDING[partner];
  if (!branding) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn(`[partnerBranding] REACT_APP_PARTNER_NAME="${partner}" sem branding configurado.`);
    }
    return null;
  }

  return branding;
}

/** @deprecated Use getPartnerBranding().menu */
export function getPartnerMenuLogoPaths(): PartnerBranding['menu'] | null {
  const branding = getPartnerBranding();
  return branding?.menu ?? null;
}
